export class Customer {
    constructor(
        public companyAddress:string =  "",
        public companyCity: string = "",
        public companyState:string =  "",
        public companyCountry:string =  "",
        public companyPinCode:string =  "",
        public billingContactName: string = "",
        public billingContactDesignation:string =  "",
        public billingUserName: string = "",
        public billingContactEmail: string =  "",
        public billingContactPhone: string = "",
        public decisionMakerName: string =  "",
        public decisionMakerDesignation: string = "",
        public decisionMakerEmail: string =  "",
        public decisionMakerPhone: string =  "",
        public hrName: string =  "",
        public goLiveDate: null | Date | string =  "",
        public paymentDate: null | Date | string =  "",
        public hrDesignation: string =  "",
        public hrEmail: string =  "",
        public hrContactPhone: string =  "",
        public technicalAdminName: string =  "",
        public technicalAdminDesignation: string =  "",
        public technicalAdminEmail: string = '',
        public technicalAdminPhone: string = '',
        public goodsServiceTax : string = '',
        public registeredCompanyName: string = '',
        public customerSizeId: number | string = '',
        public billingAddress: string = '',
        public billingZipCode: string = '',
        public discountApplicable: string = '',
        public hold: string = '',
        public customerDeploymentType: string = '',
        public customerOtherType: string = '',
        public customerType: string = '',
        public billingType: string = 'C',
        public customerId: Number = 0,
        public hbSpotId: string = '',
        public sapid: string = '',
        public group : string = '',
        public customerCode: string = '',
        public customerName: string= '',
        public status: boolean=  true,
        public sourceType: string = '',
        public domainCode: string = '',
        public companyNature: string = '',
        public registeredMobileUser : String = '',
        public permanentAccountNumber : string = '',
        public remarks : String = '',
        public salespersonEmail : String = '',
        public salespersonMobile : String = '',
        public salespersonName : String = '', 
        public subscriptionDateBasedOn : string = 'P',
        public subscriptionNoOfDays : number | string = '',
        public attachmentFourFileName : String = '', 
        public attachmentFourUploadedFileName : String = '', 
        public attachmentOneFileName : String = '', 
        public attachmentOneUploadedFileName : String = '', 
        public attachmentThreeFileName : String = '', 
        public attachmentThreeUploadedFileName : String = '', 
        public attachmentTwoFileName : String = '', 
        public attachmentTwoUploadedFileName : String = '', 
        public purchaseOrderDate : string = '',
        public priceEscalationDate : string ='',
        public priceEscalationPercentage : string ='',
        public billingCycleChangeRemarks : string = '',
        public databaseCreatedDate: string = '',
        public customerGroupId: string='',
        public isDbCreated: string=''
    ) { }
}

export class Product {
    constructor(
        public customerId: 0,
        public billingType: "M",
        public changesType: "",
        public price: [
          {
            productName:''
            productId: 0,
            productPrice: 0,
            userCount: 0,
            discountCouponCode: "",
            discountPer: 0,
            discountedAmount : 0
          }
        ]
      

    ) { }
}

export interface CustomerAdminAction {
    actionType?: string;
    actionUserId?: number;
    domainCode?: string;
    noOfDaysForStop?: number;
    isHrdeskStop: boolean;
    hrdeskStopComment: string;
    isBillingAlert: boolean;
    billingAlertComment: string;
    isPaymentDueAlert: boolean;
    paymentDueAlertComment: string;
    createdDate?: Date;
    noOfDaysForHRStop?: number;
    noOfDaysForBDStop?: number;
    noOfDaysForPDStop?: number;
    adminActionId?:number
}


export interface LogDetailsModel {
    requestId?: number,
    requestCount?: number,
    successCount?: number,
    failureCount?: number,
    updateBy?: string,
    updateDate?: string,
    requestType?: number
}

export interface CustomerSearchRequest {
    customerId: string,
    status: string,
    pagination: {
        pageNumber: number,
        pageSize: number
    }
}

export const customerCardReqData: CustomerSearchRequest = {
    customerId: "",
    status: "0,1",
    pagination: {
      pageNumber: 0,
      pageSize: 0
    }
};

export interface DeployementTypeModel {
    key : string;
    value : string;
}

export enum URLS {
    pendingCustomer = '/api/Customer/Pending/List',
    freeCustomer = '/api/Customer/Free/List',
    getCustomer = '/api/Customer/List',
    updateCustomer = '/api/Customer/Update',
    insertCustomer = '/api/Customer/Insert',
    convertToPO = '/api/Customer/Free/ConvertToPaidCustomer',
    save = '/api/Customer/Product',
    coupunDropdown = '/api/CustomerDiscount/Coupon/Dropdown',
    productDetails = '/api/Customer/Product/Request/Details/',
    productList = '/api/Customer/ProductList/',
    upsertCustomer = '/api/externalExpose/customer/Upsert',
    externalProductList = '/api/externalExpose/customer/ProductList/',
    externalSave = '/api/externalExpose/customer/Product',
    productDeatilsExternal = '/api/externalExpose/customer/Product/Request/Details/',
    countryDd = '/api/customer/Country',
    stateDd = '/api/customer/State',
    postToSap = '/api/Customer/PushCustomerToSap',
    postToHrone = '/api/hrone/subscription/publish',
    internalValidate = '/api/Customer/Product/Validate',
    externalValidate = '/api/externalExpose/customer/Product/Validate',
    adminAction = '/api/Customer/AdminAction',
    activityLog = '/api/Customer/ActionAlert',
    invoiceSyncDetails = '/api/update/sap/invoiceDetails/ToCustomer',
    invoiceDetails = '/api/Customer/InvoiceDetails',
    invoiceExternalDetails = '/api/externalExpose/customer/InvoiceDetails',
    addUserTrial = '/api/Customer/Change/Trial/User/',
    addUserTrialExternal = '/api/externalExpose/Customer/Change/Trial/User/',
    addProductTrial = '/api/Customer/Change/Trial/Module',
    addProductTrialExternal = '/api/externalExpose/Customer/Change/Trial/Module',
    stopTrialSubscription = '/api/Customer/Stop/Subscription/Trial',
    stopTrialSubscriptionExternal = '/api/externalExpose/Customer/Stop/Subscription/Trial',
    customerGroupList = '/api/Customer/Group/Details',
    externalCustomerGroupList = '/api/externalExpose/customer/Group/Details',
    insertGroup = '/api/Customer/Group/Insert',
    insertExternalGroup = '/api/externalExpose/customer/Group/Insert',
    fileUpload = '/api/super/file/Upload',
    downloadFile = '/api/super/file/FileVirtualUrl?fileDbName=',
}

export interface TerminationReasonModel {
    reasonId: number,
    reasonName: string,
    reasonType: string
}

export interface ChangeSubscriptionModel {
    clientComments: string,
    clientPrimaryReasonId: number,
    clientSecondaryReasonId: number,
    customerId: number,
    domainCode: string,
    internalComments: string,
    internalPrimaryReasonId: number,
    internalSecondaryReasonId: number,
    internalTerminationDate: string,
    terminationDate: string,
}

export interface CompanyGroupModel {
    customerGroupId: number,
    customerGroupName: string,
    displayName: string,
    customerDomain: string
}

export const GrandTotalBS : GrandTotalModel = { module: { productPrice: 0, userCount: 0, discountedAmount: 0, totalPrice: 0 ,discountedPrice: 0}, addOn: { productPrice: 0, userCount: 0, discountedAmount: 0, totalPrice: 0 }, integration: { productPrice: 0, userCount: 0, discountedAmount: 0, totalPrice: 0 } };

export interface GrandTotalModel {
    module: {
        productPrice: number;
        userCount: number;
        discountedAmount: number;
        totalPrice: number;
        discountedPrice:number;
    };
    addOn: {
        productPrice: number;
        userCount: number;
        discountedAmount: number;
        totalPrice: number;
    };
    integration: {
        productPrice: number;
        userCount: number;
        discountedAmount: number;
        totalPrice: number;
    }
}

export const modifyUserArray = [{ key: 'Add', value: 'Add' }, { key: 'Remove', value: 'Remove' }];

export interface CustomerDropDownModel {
    customerId: number,
    customerName: string,
    domainCode: string
}

export interface EmployeeSizeModel {
    sizeId: number;
    sizeName: string;
    sizeFrom: number;
    sizeTo: number;
    status: boolean;
}

export const valueReset = {
    key: 0, value: ''
}

export interface ManageAPITabModel {
    categoryScopeDetails: CategoryScopeDetail[];
    scopeCategoryId: number;
    scopeCategoryName: string;
}

export interface CategoryScopeDetail {
    pkDomainScopeId: number;
    scopeId: number;
    scopeName: string;
    scopeDescription: string;
    scopeCategoryId: number;
    isActive: boolean;
}
